const DO = {
  ibanLength: 28,
  countryConfig: {
    accountNumber: {
      visible: false,
    },
    IBAN: {
      visible: true,
      required: true,
      label: "bankDetails.IBAN",
    },
    swift: {
      visible: true,
      required: true,
      label: "bankDetails.swift",
    },
    bankName: {
      visible: false,
      required: false,
    },
    bankAddress: {
      visible: false,
      required: false,
    },
  },
};
export { DO };
